export const UserOrganizationMembershipWithUserFragment = gql`
  fragment UserOrganizationMembershipWithUserFragment on UserOrganizationMembership {
    id
    isOptedOutFromAicaDigest
    canViewForeignValues
    createdAt
    group
    hasCodeV1Access
    isAIStaffMember
    isCodeViolationsEmployeeReference
    isInspector
    isLandingPageEmployeeReference
    isPermittingEmployeeReference
    isPlanReviewer
    recordTypeAccesses {
      id
      recordType {
        id
        name
      }
    }
    roles
    title
    user {
      ...UserDataFragmentWithRecordTypeAccesses
    }
  }
`

export const UserOrganizationMembershipDigestFragment = gql`
  fragment UserOrganizationMembershipDigestFragment on UserOrganizationMembership {
    id
    group
    isAIStaffMember
    isOptedOutFromAicaDigest
    isOptedOutFromAicaUsageNotice
    user {
      ...UserDataFragment
    }
  }
`
